import { useNavigate } from 'react-router-dom';
import { useSeoMeta } from '@unhead/react';
import { CreditCard } from 'lucide-react';
import { nip19 } from 'nostr-tools';
import { LoginArea } from '@/components/auth/LoginArea';
import { ProfileSearch } from '@/components/ProfileSearch';
import { ExampleCards } from '@/components/ExampleCards';
import { useCurrentUser } from '@/hooks/useCurrentUser';

const Index = () => {
  useSeoMeta({
    title: 'CardFlip — Nostr Business Cards',
    description:
      'Turn any Nostr profile into a double-sided business card themed with the owner\'s Ditto profile theme.',
  });

  const navigate = useNavigate();
  const { user } = useCurrentUser();

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-100">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -top-40 left-1/4 h-96 w-96 rounded-full bg-violet-600/25 blur-3xl" />
        <div className="absolute top-1/4 -right-32 h-96 w-96 rounded-full bg-fuchsia-600/20 blur-3xl" />
      </div>

      <div className="relative z-10 flex min-h-screen flex-col">
        <header className="order-last flex items-center justify-between px-6 py-6 sm:order-none sm:py-5 sm:px-10">
          <div className="flex items-center gap-2 font-bold tracking-tight">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-violet-500 to-fuchsia-500 shadow-lg">
              <CreditCard className="h-5 w-5 text-white" />
            </span>
            <span className="text-lg">CardFlip</span>
          </div>
          <LoginArea className="max-w-52" />
        </header>

        <main className="flex flex-1 flex-col items-center justify-center px-6 pb-12 pt-10 sm:px-10 sm:pt-4">
          <div className="mb-8 flex w-full max-w-3xl items-center justify-center py-4 sm:mb-12">
            <ExampleCards />
          </div>

          <div className="w-full max-w-lg text-center">
            <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">
              Nostr business cards
            </h1>
            <div className="mt-6">
              <ProfileSearch />
            </div>
            {user && (
              <button
                onClick={() => navigate(`/${nip19.npubEncode(user.pubkey)}`)}
                className="mt-4 text-sm text-violet-300 transition-colors hover:text-violet-200"
              >
                View my card →
              </button>
            )}
          </div>
        </main>

        <footer className="px-6 py-6 text-center text-xs text-slate-500 sm:px-10">
          <a
            href="https://shakespeare.diy"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-slate-300"
          >
            Vibed with Shakespeare
          </a>
        </footer>
      </div>
    </div>
  );
};

export default Index;
